import { render } from "./CategoryServiceOtherSpecialists.vue?vue&type=template&id=234dfda7&scoped=true&ts=true"
import script from "./CategoryServiceOtherSpecialists.vue?vue&type=script&lang=ts"
export * from "./CategoryServiceOtherSpecialists.vue?vue&type=script&lang=ts"

import "./CategoryServiceOtherSpecialists.vue?vue&type=style&index=0&id=234dfda7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234dfda7"]])

export default __exports__